import * as actionType from '../constants/constant.action'

const defaultState = {
  serverError: false,
}

const serverErrorReducer = (state = defaultState, action) => {
  switch (action.type) {
    case actionType.SERVER_ERROR_FAILURE:
      return {
        ...state,
        serverError: true,
      }
    case actionType.SERVER_ERROR_SUCCESS:
      return {
        ...state,
        serverError: false,
      }
    default:
      return state
  }
}

export default serverErrorReducer
